import React, { Component } from 'react';
import Files from 'react-files'
import ExtractFiles from '../components/ExtractFiles'

export default class Home extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			response: []
		};
	}

	renderTest() {
		return (
			<div className="test">
				<b>NicMic</b>
				<ExtractFiles />
			</div>
		);
	}

	render() {
		return <div className="Home">{this.renderTest()}</div>;
	}
}
